// src/app/redux/sagas/niveauCriticiteSaga.js

import { call, put } from "redux-saga/effects";
import Swal from "sweetalert2";
import {
    fetchNiveauCriticiteRequest,
    fetchNiveauCriticiteSuccess,
    fetchNiveauCriticiteFail,
    createNiveauCriticiteSuccess,
    createNiveauCriticiteFail,
    updateNiveauCriticiteSuccess,
    updateNiveauCriticiteFail,
    deleteNiveauCriticiteSuccess,
    deleteNiveauCriticiteFail,
    setNiveauCriticiteLoading,
} from "../actions/niveauCriticiteActions";

import { API_BASE_URL, getRequest, postRequest, putRequest, deleteRequest } from "../../../api";

const getUid   = () => sessionStorage.getItem("uid");
const getToken = () => sessionStorage.getItem("token");

export function* fetchNiveauCriticiteSaga() {
    const url   = `${API_BASE_URL}/api/niveaux-criticite`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauCriticiteLoading(true));
    try {
        const resp = yield call(getRequest, { url, uid, token });
        yield put(fetchNiveauCriticiteSuccess(resp.data));
    } catch (e) {
        yield put(fetchNiveauCriticiteFail(e.response?.data?.message || e.message));
    } finally {
        yield put(setNiveauCriticiteLoading(false));
    }
}

export function* createNiveauCriticiteSaga(action) {
    const url   = `${API_BASE_URL}/api/niveaux-criticite`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauCriticiteLoading(true));
    try {
        const resp = yield call(postRequest, { url, data: action.payload, uid, token });
        yield put(createNiveauCriticiteSuccess(resp.data));
        yield put(fetchNiveauCriticiteRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau criticité ajouté", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(createNiveauCriticiteFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur ajout niveau criticité", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setNiveauCriticiteLoading(false));
    }
}

export function* updateNiveauCriticiteSaga(action) {
    const { id, payload } = action.payload;
    const url   = `${API_BASE_URL}/api/niveaux-criticite/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauCriticiteLoading(true));
    try {
        const resp = yield call(putRequest, { url, data: payload, uid, token });
        yield put(updateNiveauCriticiteSuccess(resp.data));
        yield put(fetchNiveauCriticiteRequest());
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau criticité modifié", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(updateNiveauCriticiteFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: e.response?.data?.message || "Erreur modification niveau criticité", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setNiveauCriticiteLoading(false));
    }
}

export function* deleteNiveauCriticiteSaga(action) {
    const { id } = action.payload;
    const url   = `${API_BASE_URL}/api/niveaux-criticite/${id}`;
    const uid   = getUid();
    const token = getToken();

    yield put(setNiveauCriticiteLoading(true));
    try {
        yield call(deleteRequest, { url, uid, token });
        yield put(deleteNiveauCriticiteSuccess(id));
        yield call([Swal, Swal.fire], { icon: "success", text: "Niveau criticité supprimé", timer: 1500, showConfirmButton: false });
    } catch (e) {
        yield put(deleteNiveauCriticiteFail(e.response?.data?.message || e.message));
        yield call([Swal, Swal.fire], { icon: "error", text: "Erreur suppression niveau criticité", timer: 1800, showConfirmButton: false });
    } finally {
        yield put(setNiveauCriticiteLoading(false));
    }
}
